import type { ContentSquareComponent, TestableComponent } from '@mweb/types';

import { cn } from 'helpers/classnames';

interface ProductCardHorizontalDetailsItemProps extends ContentSquareComponent, TestableComponent {
  LinkComponent?: React.ElementType<any>;
  className?: string;
  isBoldPrefixLabel?: boolean;
  isBoldValue?: boolean;
  label: string;
  prefixLabel?: string;
  url?: string;
  value: string | number;
  valueClassName?: string;
}

export const ProductCardHorizontalDetailsItem = (props: ProductCardHorizontalDetailsItemProps) => {
  const {
    label,
    value,
    testId,
    url,
    prefixLabel,
    className,
    hasDataCsMask,
    LinkComponent = 'a',
    isBoldValue,
    isBoldPrefixLabel,
    valueClassName,
    ...forwardProps
  } = props;

  return (
    <>
      {/* We don't need to provide a dt if there is a prefix label in the html that describes the dd */}
      {!prefixLabel && <dt aria-label={label} />}
      <dd className={cn('body-s', className)} data-testid={testId} data-cs-mask={hasDataCsMask}>
        {url ? (
          <LinkComponent className={cn(isBoldValue ? 'font-semibold' : 'font-normal', valueClassName)} href={url} {...forwardProps}>
            {value}
          </LinkComponent>
        ) : (
          <>
            {prefixLabel && <span className={cn(isBoldPrefixLabel ? 'font-semibold' : 'font-normal')} {...forwardProps}>{`${prefixLabel}: `}</span>}
            <span className={cn(isBoldValue ? 'font-semibold' : 'font-normal', valueClassName)}>{value}</span>
          </>
        )}
      </dd>
    </>
  );
};

ProductCardHorizontalDetailsItem.displayName = 'ProductCardHorizontalDetailsItem';
